<template>
  <component
    :is="controlComponent"
    ref="control"
    class="ui-time-picker"
    :class="{ 'is-block': block }"
    :value="value"
    :popper-class="resolvedPopperClass"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event)"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'UiTimePicker',
  inheritAttrs: false,
  props: {
    value: { default: '' },
    mode: {
      type: String,
      default: 'picker',
      validator: value => ['picker', 'select'].includes(value)
    },
    block: { type: Boolean, default: false },
    popperClass: { type: String, default: '' }
  },
  computed: {
    controlComponent () {
      return this.mode === 'select' ? 'el-time-select' : 'el-time-picker'
    },
    resolvedPopperClass () {
      return [
        'terminal-dropdown-menu',
        'terminal-picker-panel',
        'terminal-time-picker',
        this.mode === 'select' ? 'terminal-time-select' : '',
        this.popperClass
      ].filter(Boolean).join(' ')
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      return listeners
    }
  },
  methods: {
    focus () {
      const input = this.$el && this.$el.querySelector('input')
      if (input) input.focus()
    },
    blur () {
      const input = this.$el && this.$el.querySelector('input')
      if (input) input.blur()
    }
  }
}
</script>

<style lang="scss">
.ui-time-picker {
  height: var(--ui-control-height);
  box-sizing: border-box;
  vertical-align: top;
}

.ui-time-picker.is-block {
  width: 100% !important;
}

.ui-time-picker.el-input,
.ui-time-picker.el-range-editor {
  height: var(--ui-control-height);
  border-color: var(--ui-control-rest-border);
  border-radius: var(--ui-radius-medium);
  background: linear-gradient(var(--ui-control-rest-background), var(--ui-control-rest-background)), var(--ui-bg-control);
}

.ui-time-picker .el-input__inner {
  height: var(--ui-control-height);
  color: var(--ui-text-primary);
  border-color: var(--ui-control-rest-border);
  border-radius: var(--ui-radius-medium);
  background: linear-gradient(var(--ui-control-rest-background), var(--ui-control-rest-background)), var(--ui-bg-control);
  font-size: var(--ui-font-size-form-control);
  line-height: var(--ui-control-height);
}

.ui-time-picker .el-range-input {
  color: var(--ui-text-primary);
  background: transparent;
  font-size: var(--ui-font-size-form-control);
}

.ui-time-picker .el-input__inner::placeholder,
.ui-time-picker .el-range-input::placeholder {
  color: var(--ui-control-rest-placeholder);
}

.ui-time-picker .el-input__icon,
.ui-time-picker .el-range__icon,
.ui-time-picker .el-range-separator,
.ui-time-picker .el-range__close-icon {
  color: var(--ui-text-secondary);
  line-height: calc(var(--ui-control-height) - 2px);
}
</style>
